module.exports = __webpack_public_path__ + "img/simonacastro.9a473a8b.jpg";